import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { useSettingsCollection } from "@starter/Framework/Store/Context/ContextHooks";

const useTrackPageView = (parameters: TrackPageViewParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    const hookParameters: TrackPageViewParameters = {
        client_id: ga.use.clientId(options),
        language: ga.use.language(options),
        page_type: ga.use.pageType(options),
        settingsCollection: useSettingsCollection(),
        websiteName: useAppSelector(state => state.context.website.name),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        ...options,
    };

    return (parameters: Partial<TrackPageViewParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.pageView({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackPageView;
